import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Radio,
  Result,
  Row,
  Select,
  Slider,
  Switch,
  Typography,
  Upload
} from 'antd';
import Moment from 'react-moment';
import seguridadProvider from '../../../services/seguridadProvider';
import {
  CalendarOutlined,
  FrownOutlined,
  InfoCircleOutlined,
  SmileOutlined,
  UploadOutlined,
  UserOutlined
} from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/es_ES';
import jwt_decode from 'jwt-decode';
import generalesProvider from '../../../services/generalesProvider';
// import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import FichaPreview from '../pdf/fichaPreview';
import saludProvider from '../../../services/saludProvider';
import administracionProvider from '../../../services/administracionProvider';
import Paragraph from 'antd/lib/typography/Paragraph';
import Title from 'antd/lib/typography/Title';

const { Text } = Typography;
const { Option } = Select;

const key = 'regitrando';
const Covid = () => {
  const token = localStorage.getItem('token');
  const [mostrarValidarUsuario, setMostrarValidarUsuario] = useState(true);
  const [puestos, setpuestos] = useState([]);
  const [tokenvalue, settokenvalue] = useState({ exp: 0 });
  const [cargando, setCargando] = useState(false);
  const [cargandoEmpresas, setCargandoEmpresas] = useState(false);
  const [cargandoContacto, setCargandoContacto] = useState(false);
  const [adjunto, setAdjunto] = useState({});
  const [adjuntos, setadjuntos] = useState([]);
  const [lecturaFicha, setLecturaFicha] = useState({
    id: 0,
    codigo: '',
    nombreApellido: '',
    estadoId: 0,
    enfermedadesRelacionadas: ''
  });
  const [empresas, setEmpresas] = useState([]);
  const [mostrarRegistrarUsuario, setMostrarRegistrarUsuario] = useState(false);
  const [cargandoRegistrarUsuario, setCargandoRegistrarUsuario] = useState(false);
  const [radioValue1, setRadioValue1] = useState(2);
  const [radioValue2, setRadioValue2] = useState(2);
  const [radioValue3, setRadioValue3] = useState(2);
  const handleRadioChange1 = (e) => setRadioValue1(e.target.value);
  const handleRadioChange2 = (e) => setRadioValue2(e.target.value);
  const handleRadioChange3 = (e) => setRadioValue3(e.target.value);
  const [usuario, setUsuario] = useState({ EmpresaId: 0, Apellidos: '', Nombres: '', Dni: '' });

  const [validarFiebre, setValidarFiebre] = useState(false);
  const [validarGusto, setValidarGusto] = useState(false);
  const [validarExpectoracion, setValidarExpectoracion] = useState(false);

  useEffect(() => {}, [mostrarValidarUsuario]);

  useEffect(() => {
    generalesProvider.obtenerListaValor(7).then((res: any) => {
      setpuestos(res);
    });
    if (token) {
      const token_decode: any = jwt_decode(token);
      settokenvalue(token_decode);
      const d = new Date(0);
      d.setUTCSeconds(token_decode.exp);
      if (d <= new Date()) {
        setMostrarValidarUsuario(true);
        settokenvalue(null);
        localStorage.removeItem('token');
        message.warning('Finalizo sesión vuelva a ingresar.', 5);
      } else {
        setMostrarValidarUsuario(false);
        obtenerEmpresas().then(() => {
          iniciarValores();
        });
      }
    }
  }, []);

  const [restringido, setrestringido] = useState(false);

  const iniciarValores = async () => {
    let tk: any = jwt_decode(localStorage.getItem('token'));
    settokenvalue(tk);
    const usr = JSON.parse(tk.data);
    if (usr.RestriccionAcceso == null || !usr.RestriccionAcceso) {
      message.success('Datos validos...');
      await obtenerEmpresas();
      setMostrarValidarUsuario(false);
      form.resetFields();
      const val = {
        EmpresaId: usr.EmpresaId,
        ruc: usr.Ruc,
        NombreApellido: usr.Apellidos + ' ' + usr.Nombres,
        Dni: usr.Dni,
        Referencia: usr.ContactoReferencia,
        TelefonoReferencia: usr.TelefonoReferencia,
        Direccion: usr.Direccion,
        Telefono: usr.Telefono,
        Puesto: usr.Puesto,
        Fiebre: false,
        TosSeca: false,
        GustoPerdida: false,
        DolorCabezaDiarrea: false,
        Flema: false,
        CercaniaCovid: null,
        PerteneceGrupoRiesgoCovid: null,
        Medicacion: null,
        MedicacionDescripcion: '',
        Terminos: false,
        Observaciones: ''
      };
      form.setFieldsValue(val);
      if (usr.Observacion4) {
        message.success(
          'Se encuentra en observación por cada 4 horas por declarar sintomatologia.',
          10
        );
      }
    } else {
      setrestringido(true);
      localStorage.removeItem('token');
      if (usr.Aislamiento7) {
        //se quita los dias
        message.error('Se encuentra con restricción de acceso por declarar sintomatologia.', 10);
      } else if (usr.Aislamiento14) {
        //quitar los dias
        message.error('Se encuentra con restricción de acceso por declarar sintomatologia.', 10);
      } else if (usr.Observacion4) {
        message.error(
          'Se encuentra en observación por cada 4 horas por declarar sintomatologia.',
          10
        );
      } else if (usr.RestriccionAcceso) {
        message.error('Se encuentra con restricción de acceso.', 10);
      }
      form.resetFields();
      setMostrarValidarUsuario(true);
    }
  };

  const [registroOk, setRegistroOk] = useState(false);
  const [ficha, setficha] = useState({
    codigo: '',
    estadoId: 0,
    nombreApellido: '',
    fechaReg: '',
    dni: '',
    direccion: ''
  });

  const [form] = Form.useForm();

  const handleOnFinish = async (val) => {
    if (radioValue1 && adjuntos.length === 0) {
      message.warning({
        content: 'Es necesario adjuntar la prueba COVID-19 del contacto confirmado',
        key
      });
      return;
    }

    if (tokenvalue) {
      const d = new Date(0);
      d.setUTCSeconds(tokenvalue.exp);
      if (d <= new Date()) {
        //FINALIZO
        message.loading({
          content: 'Finalizo su sesión...Se recargara la pagina en 3 segundos...',
          key
        });
        setTimeout(() => window.location.reload(), 3000);
      } else {
        message.loading({ content: 'Registrando...', key });
        setCargando(true);
        val.EstadoId = 1;
        // return;

        const res: any = await saludProvider.guardarFicha(val);
        if (res) {
          if (res.id != 0) {
            if (adjuntos.length > 0) {
              await administracionProvider.guardarAdjunto(res, adjuntos);
            }
            setRegistroOk(true);
            setCargando(false);
            setficha(res);
            localStorage.removeItem('token');
            form.resetFields();
          } else {
            message.info({ content: 'No existe usuario', key, duration: 5 });
            setCargando(false);
            setMostrarRegistrarUsuario(true);
          }
        }
      }
    }
  };

  const buscarContacto = async (val) => {
    setCargandoContacto(true);
    const response: any = await seguridadProvider.obtenerContacto(val.currentTarget.value);
    setCargandoContacto(false);
    form.setFieldsValue({
      Referencia: response.contactoReferencia,
      TelefonoReferencia: response.telefonoReferencia,
      Direccion: response.direccion,
      Telefono: response.telefono
    });
  };

  const obtenerEmpresas = async () => {
    setCargandoEmpresas(true);
    const response: any = await administracionProvider.obtenerEmpresas();
    setEmpresas(response);
    setCargandoEmpresas(false);
  };

  const useResetFormOnCloseModal = ({ form, visible }) => {
    const prevVisibleRef = useRef();
    useEffect(() => {
      prevVisibleRef.current = visible;
    }, [visible]);
    const prevVisible = prevVisibleRef.current;
    useEffect(() => {
      if (!visible && prevVisible) {
        form.resetFields();
      }
    }, [visible]);
  };

  const ModalForm = ({ visible }) => {
    const [form] = Form.useForm();
    const [validando, setValidando] = useState(false);
    useResetFormOnCloseModal({ form, visible });

    const onOk = () => {
      form
        .validateFields()
        .then(async (val) => {
          setValidando(true);
          const response = await seguridadProvider
            .validarUsuario({
              Dni: val.dni,
              FechaNacimiento: val.fecha.format('DD/MM/YYYY')
            })
            .catch((err) => {
              if (err.response.status === 401) {
                message.warning(
                  'El número de documento o fecha de nacimiento que ingresaste es incorrecto...'
                );
                form.resetFields();
              }
            });
          setValidando(false);
          if (response) {
            // intervalo();
            iniciarValores();
          }
        })
        .catch((info) => {
          console.log('Validate Failed:', info);
        });
    };

    return (
      <Modal
        title={'Ingresa tu documento de identidad para iniciar registro de signo(s) y/o síntoma(s)'}
        closable={false}
        visible={visible}
        onOk={onOk}
        centered={false}
        footer={[
          <Button key='submit' type='primary' loading={validando} onClick={onOk}>
            Validar
          </Button>
        ]}
      >
        <p>
          <InfoCircleOutlined twoToneColor='#eb2f96' /> Ten en cuenta que la información que
          proporciones tiene carácter de Declaración Jurada.
        </p>
        <Form form={form} layout='vertical' name='userForm'>
          <Form.Item
            name='dni'
            label='Número de documento'
            rules={[{ required: true, message: 'Número de documento es requerido' }]}
          >
            <Input placeholder={'Ingrese su número de documento.'} />
          </Form.Item>
          <Form.Item
            name='fecha'
            label='Fecha de nacimiento'
            rules={[{ required: true, message: 'Fecha de nacimiento es requerido' }]}
          >
            <DatePicker placeholder={'dd/mm/yyyy'} locale={locale} format={'DD/MM/yyyy'} />
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const mostrarPdf = async () => {
    message.info('Generando informe...');
    setVerPdf(true);
  };

  const [verPdf, setVerPdf] = useState(false);

  const OPTIONS = [
    'Mayor de 65 años',
    'Cáncer',
    'Enfermedad renal crónica',
    'Afecciones cardiacas',
    'DM tipo 1 o 2',
    'Obesidad (IMC>30)',
    'Inmunosupresión',
    'Receptor de trasplante de órgenos',
    'Enfermedad cerebrovascular',
    'Hipertensión arterial',
    'Síndrome de Down',
    'Embarazo',
    'Infección por VIH',
    'Otros'
  ];
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const filteredOptions = OPTIONS.filter((o) => !selectedItems.includes(o));

  const FichaPdf = () => FichaPreview(ficha);

  const removeAdjunto = (file) => {
    const index = adjuntos.indexOf(file);
    const newFileList = adjuntos.slice();
    newFileList.splice(index, 1);
    setadjuntos([...newFileList]);
    setAdjunto({});
  };
  const beforeAdjunto = (file, files) => {
    setAdjunto(file);
    setadjuntos(files);
    return false;
  };

  const seleccionFiebre = (val) => {
    setValidarFiebre(val.target.checked);
  };

  return (
    <>
      <Modal
        title={'Ficha'}
        centered
        visible={verPdf}
        onOk={() => setVerPdf(false)}
        onCancel={() => setVerPdf(false)}
        width={1000}
      >
        <Row>
          <Col>
            {/*<PDFDownloadLink document={<FichaPdf />} fileName='ficha.pdf'>*/}
            {/*  {({ blob, url, loading, error }) => (loading ? 'Descargando...' : 'Descargar')}*/}
            {/*</PDFDownloadLink>*/}
          </Col>
        </Row>
        {/*<PDFViewer style={{ width: '100%', height: '400px' }}>*/}
        {/*  {<FichaPdf />}*/}
        {/*</PDFViewer>*/}
      </Modal>
      <Row>
        <Col span={24}>
          <Title level={4}>
            FICHA DE SINTOMATOLOGÍA DE LA COVID-19 PARA REGRESO O REINCORPORACIÓN AL TRABAJO
            DECLARACIÓN JURADA.
          </Title>
        </Col>
      </Row>
      {registroOk ? (
        <Result
          icon={
            ficha.estadoId === 1 ? (
              <SmileOutlined style={{ color: '#27AE60' }} />
            ) : (
              <FrownOutlined style={{ color: '#E74C3C' }} />
            )
          }
          title={ficha.estadoId === 1 ? 'PUEDE INGRESAR' : 'NO PUEDE INGRESAR'}
          extra={[
            <Button type='primary' key='console' onClick={mostrarPdf}>
              Mostrar Ficha
            </Button>
          ]}
        >
          <div className='desc'>
            <Paragraph>
              <Text strong style={{ fontSize: 16 }}>
                Ficha: {ficha.codigo}
              </Text>
            </Paragraph>
            <Paragraph>
              <UserOutlined /> {ficha.nombreApellido}
            </Paragraph>
            <Paragraph>
              <CalendarOutlined /> <Moment format={'LLL'}>{ficha.fechaReg}</Moment>
            </Paragraph>
            {ficha.estadoId === 1 ? null : (
              <div>
                <p>Con lo declarado informa a tu jefe inmediato sobre tu aislamiento</p>
                <p>
                  De acuerdo a los lineamientos del <strong>MINSA</strong>, Ud deberá permanecer en
                  su domicilio, se le restringe el desplazamiento fuera de su vivienda o centro de
                  aislamiento salvo para atención médica. Si presenta síntomas recuerde que puede
                  comunicarse con el MINSA, tienes a disposición los siguientes canales de
                  comunicación.
                </p>
                <p>Línea gratuita: 113</p>
                <p>Whatsapp: 952842623</p>
                <p>Correo: infosalud@minsa.gob.pe</p>
                <p>
                  El servicio médico ocupacional se comunicará con usted para realizar su
                  seguimiento como parte de la vigilancia médica.
                </p>
              </div>
            )}
          </div>
        </Result>
      ) : (
        <Card>
          {/* <h5>He recibido explicación del objetivo de esta evaluación y me comprometo a responder con la verdad.</h5> */}
          <Form form={form} onFinish={handleOnFinish} labelAlign='left' layout='horizontal'>
            <Form.Item label='key' name='EmpresaId' noStyle>
              <Input type='hidden' />
            </Form.Item>
            <Form.Item label='key' name='ruc' noStyle>
              <Input type='hidden' />
            </Form.Item>
            {/* <div className='row'>
            <div className='col-md-8'>
              <Form.Item name='EmpresaId' label='Razón social:'>
                <Select placeholder='Seleccione Razón social' loading={cargandoEmpresas}>
                  {
                    empresas.map((p, index) => {
                      return (
                        <Option key={index} value={p.id}>{p.nombre}</Option>
                      );
                    })
                  }
                </Select>
              </Form.Item>
            </div>
            <div className='col-md-4'>
              <Form.Item name='ruc' label='RUC:'>
                <Input disabled={true} placeholder='Ingrese Ruc..' />
              </Form.Item>
            </div>
          </div> */}
            <div className='row'>
              <div className='col-md-6'>
                <Form.Item name='NombreApellido' label='Apellidos y Nombres:'>
                  <Input allowClear={true} placeholder='Ingrese Apellidos y Nombres' />
                </Form.Item>
              </div>
              <div className='col-md-2'>
                <Form.Item
                  name='Dni'
                  validateStatus='validating'
                  hasFeedback={cargandoContacto}
                  label='DNI:'
                >
                  <Input onPressEnter={buscarContacto} placeholder='Dni' id='validating' />
                </Form.Item>
              </div>
              <div className='col-md-4'>
                <Form.Item name='Puesto' label='Puesto:'>
                  <Input readOnly={true} />
                </Form.Item>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-8'>
                <Form.Item name='Direccion' label='Ingresa tu dirección:'>
                  <Input placeholder='Ingrese Dirección...' />
                </Form.Item>
              </div>
              <div className='col-md-4'>
                <Form.Item name='Telefono' label='Teléfono:'>
                  <Input placeholder='Ingrese Telefono' />
                </Form.Item>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-8'>
                <Form.Item name='Referencia' label='Contacto referencia:'>
                  <Input />
                </Form.Item>
              </div>
              <div className='col-md-4'>
                <Form.Item name='TelefonoReferencia' label='Telefono de referencia:'>
                  <Input />
                </Form.Item>
              </div>
            </div>
            <Text>En los últimos 10 días calendario ha tenido algunos síntomas siguientes:</Text>
            <br />
            <br />
            <Form.Item>
              <Form.Item
                name='Fiebre'
                valuePropName='checked'
                style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
              >
                <Checkbox onChange={seleccionFiebre}>
                  Sensación de alza térmica, fiebre o malestar.
                </Checkbox>
              </Form.Item>
              <Form.Item
                name='Temperatura'
                rules={[{ required: validarFiebre, message: 'Seleccione una temperatura' }]}
                style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
              >
                <Select allowClear={true} style={{ fontSize: 12 }} placeholder='Temperatura'>
                  <Option value={1}>Menor a 37.5 C°</Option>
                  <Option value={2}>38 C°</Option>
                  <Option value={3}>Mayor o igual a 38.5 C°</Option>
                </Select>
              </Form.Item>
              <Form.Item name='TosSeca' valuePropName='checked'>
                <Checkbox>Dolor de garganta, tos, estornudos o dificultad para respirar.</Checkbox>
              </Form.Item>

              <Form.Item name='DolorCabezaDiarrea' valuePropName='checked'>
                <Checkbox>Dolor de cabeza, diarrea o congestión nasal.</Checkbox>
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Form.Item
                  name='GustoPerdida'
                  valuePropName='checked'
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                >
                  <Checkbox onChange={(val) => setValidarGusto(val.target.checked)}>
                    Pérdida del gusto y/o del olfato.
                  </Checkbox>
                </Form.Item>
                <Form.Item
                  name='GustoPerdidaNivel'
                  rules={[{ required: validarGusto, message: 'Seleccione un nivel' }]}
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                >
                  <Select allowClear={true} placeholder='Nivel'>
                    <Option value={5}>Ligera</Option>
                    <Option value={6}>Total</Option>
                  </Select>
                </Form.Item>
              </Form.Item>

              {/* <Form.Item name='OlfatoPerdida' valuePropName="checked">
              <Checkbox>Pérdida del olfato.</Checkbox>
            </Form.Item>

            */}

              {/* <Form.Item style={{ marginBottom: 0 }}>
              <Form.Item name='Flema' valuePropName="checked" style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}>
                <Checkbox onChange={(val) => setValidarExpectoracion(val.target.checked)}>Expectoración de flema.</Checkbox>
              </Form.Item>
              <Form.Item name='FlemaTipo' rules={[{ required: validarExpectoracion, message: 'Seleccione un tipo' }]} style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}>
                <Select allowClear={true} placeholder='Tipo'>
                  <Option value={7}>Amarillenta</Option>
                  <Option value={8}>Verdosa</Option>
                </Select>
              </Form.Item>
            </Form.Item> */}
            </Form.Item>
            {/* <Form.Item label={'¿Ha tenido contacto con alguna persona(s) con caso confirmado de COVID-19?'}> */}
            <Form.Item label={'¿Contacto con un caso confirmado de COVID-19?'}>
              <Form.Item style={{ marginBottom: 0 }}>
                <Form.Item
                  name='CercaniaCovid'
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                >
                  <Radio.Group onChange={handleRadioChange1}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
                {form.getFieldValue('CercaniaCovid') ? (
                  <Form.Item
                    style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                  >
                    <Upload
                      fileList={adjuntos}
                      onRemove={removeAdjunto}
                      beforeUpload={beforeAdjunto}
                    >
                      <Button type={'link'} icon={<UploadOutlined />}>
                        Subir prueba COVID-19
                      </Button>
                    </Upload>
                  </Form.Item>
                ) : null}
              </Form.Item>
            </Form.Item>
            <Form.Item label={'¿Pertenece a algún Grupo de Riesgo para COVID-19 ?'}>
              <Form.Item style={{ marginBottom: 0 }}>
                <Form.Item
                  name='PerteneceGrupoRiesgoCovid'
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                >
                  <Radio.Group onChange={handleRadioChange3}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
                {form.getFieldValue('PerteneceGrupoRiesgoCovid') ? (
                  <Form.Item name={'grupoRiesgo'} style={{ display: 'inline-block', width: '50%' }}>
                    <Select
                      mode='multiple'
                      placeholder='Selecciones el grupo de riesgo'
                      value={selectedItems}
                      onChange={setSelectedItems}
                      style={{ width: '100%' }}
                      options={filteredOptions.map((item) => ({
                        value: item,
                        label: item
                      }))}
                    />
                  </Form.Item>
                ) : null}
              </Form.Item>
            </Form.Item>
            <Form.Item
              label={
                '¿Está tomando alguna medicación por posible sintomatología COVID-19? (detallar cuál o cuáles)'
              }
            >
              <Form.Item style={{ marginBottom: 0 }}>
                <Form.Item
                  name='Medicacion'
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                >
                  <Radio.Group onChange={handleRadioChange2}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  name='MedicacionDescripcion'
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                >
                  <Input.TextArea placeholder='Descripción' rows={4} />
                </Form.Item>
              </Form.Item>
            </Form.Item>
            <Form.Item
              name={'numeroVacunas'}
              label={'Estado de vacunación para SARS-CoV-2 (# de dosis)'}
            >
              <InputNumber type={'number'} />
            </Form.Item>
            <Form.Item>
              <p>
                Todos los datos expresados en esta ficha constituyen declaración jurada de mi parte.
              </p>
              <p>
                He recibido explicación del objetivo de esta evaluación y he respondido con la
                verdad.
              </p>
              <p>
                Autorizo a la empresa el adecuado uso de los datos consignados en la presente
                declaración jurada de acuerdo a lo establecido en la Ley N° 29733.
              </p>
            </Form.Item>
            <Form.Item
              name='Terminos'
              valuePropName='checked'
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject('Es necesario aceptar las condiciones.')
                }
              ]}
            >
              <Checkbox>
                Declaro y acepto los datos expresados en esta ficha, constituyen declaración jurada
                de mi parte. He sido informado de omitir o declarar información falsa puedo
                perjudicar la salud de mis compañeros de trabajo, y la mia propia, asumiendo las
                responsabilidades que correspondan. Autorizo a la empresa el adecuado uso de los
                datos consignados en la presente declaración jurada de acuerdo a lo establecido en
                la Ley N° 29733.{' '}
              </Checkbox>
            </Form.Item>
            <div className='row'>
              <div className='col-md-12'>
                <p>
                  Lima, <Moment locale={'es'}>{Date.now()}</Moment>.
                </p>
              </div>
            </div>
            <br />
            {lecturaFicha.id != 0 && lecturaFicha.estadoId == 1 && (
              <>
                <Text style={{ color: 'green' }}>
                  En base a las respuestas de la encuesta y la información configurada en el
                  sistema, el trabajador no presenta riesgo de contagio.
                </Text>
                <br />
                <br />
              </>
            )}
            {lecturaFicha.id != 0 && lecturaFicha.estadoId == 2 && (
              <>
                <Text style={{ color: 'red' }}>
                  En base a las respuestas de la encuesta y la información configurada en el
                  sistema, el trabajador presenta riesgo de contagio. Las respuestas de la encuesta
                  tambien coinciden con las siguientes sintomatologias:{' '}
                  {lecturaFicha.enfermedadesRelacionadas}
                </Text>
                <br />
                <br />
              </>
            )}

            {lecturaFicha.id != 0 && lecturaFicha.estadoId == 2 && (
              <>
                <Form.Item label='Cuarentena por'>
                  <Form.Item name='Cuarentenax' noStyle>
                    <InputNumber min={0} max={15} />
                  </Form.Item>
                  <span className='ant-form-text'> días</span>
                </Form.Item>
                <Form.Item label='Descanso médico por'>
                  <Form.Item name='Descansox' noStyle>
                    <InputNumber min={0} max={5} />
                  </Form.Item>
                  <span className='ant-form-text'> días</span>
                </Form.Item>
                <Form.Item
                  name='RestriccionAcceso'
                  label='Restricción de acceso a locales'
                  valuePropName='checked'
                >
                  <Switch />
                </Form.Item>
                <Form.Item name='Criticidad' label='Criticidad'>
                  <Slider
                    marks={{
                      0: 'Bajo',
                      20: 'Medio Bajo',
                      40: 'Medio',
                      60: 'Medio Alto',
                      80: 'Alto',
                      100: 'Critico'
                    }}
                  />
                </Form.Item>
              </>
            )}

            {lecturaFicha.id != 0 && (
              <Form.Item name='Observaciones'>
                <Input.TextArea placeholder='Observaciones del medico tratante' rows={4} />
              </Form.Item>
            )}
            <div className='row'>
              <div className='col-md-12'>
                <Form.Item>
                  <Button
                    loading={cargando}
                    disabled={restringido}
                    htmlType={'submit'}
                    type='primary'
                  >
                    {lecturaFicha.id != 0 ? 'CALIFICAR' : 'ENVIAR'}
                  </Button>
                </Form.Item>
              </div>
            </div>
          </Form>
        </Card>
      )}
      <ModalForm visible={mostrarValidarUsuario} />
    </>
  );
};

export default Covid;
